import { render } from "./OverviewProfit.vue?vue&type=template&id=a06ae4aa"
import script from "./OverviewProfit.vue?vue&type=script&lang=js"
export * from "./OverviewProfit.vue?vue&type=script&lang=js"

import "./OverviewProfit.vue?vue&type=style&index=0&id=a06ae4aa&lang=scss"

import exportComponent from "/home/ubuntu/kokoroduke-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__